import Loader from '../Loader';
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
export const GraphIndicatorContext = /*#__PURE__*/createContext([null, () => {}]);
export const useGraphIndicator = () => useContext(GraphIndicatorContext);
export const useGraphIsLoading = (name, loading) => {
  const [graphLoading, setGraphLoading] = useGraphIndicator();
  useEffect(() => {
    if (Array.isArray(graphLoading)) {
      if (loading) {
        setGraphLoading(prev => [...prev, name]);
      } else if (graphLoading.some(each => each === name)) {
        setGraphLoading(prev => prev.filter(each => each !== name));
      }
    }
  }, [loading]);
};

const GraphIndicator = ({
  activate,
  showLoading,
  children
}) => {
  const state = useState(activate ? [] : null);
  const [graphLoading, setGraphLoading] = state;
  const loading = Array.isArray(graphLoading) && graphLoading.length > 0;
  const cameFromLoading = useRef(false);
  useEffect(() => {
    if (Array.isArray(graphLoading) && !loading && cameFromLoading.current) {
      setGraphLoading(null);
    }
  }, [graphLoading]);
  useEffect(() => {
    if (Array.isArray(graphLoading) && loading) {
      cameFromLoading.current = true;
    }
  }, [graphLoading]);
  return activate ? /*#__PURE__*/React.createElement(GraphIndicatorContext.Provider, {
    value: state
  }, children, /*#__PURE__*/React.createElement(Loader, {
    active: loading && !!showLoading
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

GraphIndicator.defaultProps = {
  showLoading: true
};
export default GraphIndicator;